export class CampoObrigatorio {
  public static aplicar(value: any) {
    return value != null && value !== '';
  }

  public static aplicarComStrFalse(value: any) {
    return value != null && value !== '' && value !== 'false' && value !== false;
  }

  public static aplicarParaArray(array: Array<{ nomeArquivo: string; conteudo: string }>): boolean {
    if (array.length === 0) {
      return false;
    }
    return array.every(item =>
      this.aplicar(item.nomeArquivo) && this.aplicar(item.conteudo)
    );
  }
}
